import { useMutation, useQueryClient } from "react-query";
import type { UseMutationResult } from "react-query";
import type { AssignRoleRequest } from "common/models/api/models/AssignRoleRequest";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { rolesApi } from "../api/rolesApi";

export default function useAssignRole(
    options?: UseCustomMutationOptions<void, unknown, AssignRoleRequest>,
): UseMutationResult<void, unknown, AssignRoleRequest> {
    const queryClient = useQueryClient();

    return useMutation(
        async (body) => {
            await rolesApi.assignRole(body);
        },
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(Queries.RELEASE_STRATEGY_FIND_ALL);
                options?.onSuccess?.(data, variables, context);
            },
        },
    );
}
